import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import BarChartIcon from '@mui/icons-material/BarChart';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LinkIcon from '@mui/icons-material/Link';
import '../../../../../styles/NewsTableRow.css';
import { NEWS_STATUS_CHANGE_EVENT } from '../../../Sidebar/AdminSidebar';

const ActionButtons = ({
    item,
    showMenu,
    setShowMenu,
    handleToggleActive,
    handleDelete,
    getLanguageName
}) => {
    const navigate = useNavigate();
    const menuRef = useRef(null);
    const [showLinkFormatModal, setShowLinkFormatModal] = useState(false);

    const adNetworks = [
        { name: 'Стандартный формат', clickIdFormat: '[CLICK_ID]', params: { cpcp: '[CPCP]', tid: '[TID]', sid: '[SID]' } },
        { name: 'Формат с фигурными скобками', clickIdFormat: '{click_id}', params: { cpcp: '{cpcp}', tid: '{tid}', sid: '{sid}' } },
        { name: 'Формат с процентами', clickIdFormat: '%click_id%', params: { cpcp: '%cpcp%', tid: '%tid%', sid: '%sid%' } },
        { name: 'Только click_id', clickIdFormat: '[CLICK_ID]', params: {} }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(null);
                setShowLinkFormatModal(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setShowMenu]);

    const handleOpenUrl = (e) => {
        e.stopPropagation();
        if (item.slug) {
            window.open(`/news/${item.slug}`, '_blank');
        }
    };

    const handleGetTrackedUrl = (e, network) => {
        e.stopPropagation();
        if (item.slug) {
            const baseUrl = `https://informfeed.site/news/${item.slug}`;
            
            let paramsString = `?click_id=${network.clickIdFormat}`;
            
            Object.entries(network.params).forEach(([key, value]) => {
                paramsString += `&${key}=${value}`;
            });
            
            const trackedUrl = baseUrl + paramsString;
            
            navigator.clipboard.writeText(trackedUrl)
                .then(() => {
                    alert(`Ссылка для сети "${network.name}" скопирована в буфер обмена`);
                })
                .catch(err => {
                    console.error('Не удалось скопировать ссылку: ', err);
                    alert('Ссылка с метками: ' + trackedUrl);
                });
        }
        setShowLinkFormatModal(false);
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        if (window.confirm('Вы уверены, что хотите удалить эту новость?')) {
            handleDelete(item._id);
        }
    };

    const handleStatsClick = (e) => {
        e.stopPropagation();
        navigate(`/admin/news/${item._id}/stats`);
    };

    return (
        <div className="action-column">
            <div className="action-row">
                <div className="toggle-switch">
                    <input
                        type="checkbox"
                        checked={item.isActive}
                        onChange={() => {
                            handleToggleActive(item._id, item.isActive);
                            // Генерируем событие для обновления статистики
                            window.dispatchEvent(new CustomEvent(NEWS_STATUS_CHANGE_EVENT, {
                                detail: { 
                                    newsId: item._id,
                                    language: item.language,
                                    isActive: !item.isActive 
                                }
                            }));
                        }}
                    />
                    <span className="toggle-slider"></span>
                </div>
                <div className="info-row">
                    <span className="info-label">ID:</span>
                    <span className="info-value">{item.orderNumber || 'Не задано'}</span>
                </div>
            </div>

            <div className="info-row">
                <span>Создано: {new Date(item.createdAt).toLocaleDateString('ru-RU')}</span>
                <span>|</span>
                <span>Язык: {getLanguageName(item.language)}</span>
            </div>

            <div className="action-row">
                <button 
                    onClick={handleStatsClick}
                    className="action-link"
                >
                    <BarChartIcon style={{ fontSize: 16 }} />
                    <span>Статистика</span>
                </button>
                
                <button
                    onClick={() => navigate(`/admin/news/edit/${item._id}`)}
                    className="action-link"
                >
                    <EditIcon style={{ fontSize: 16 }} />
                    <span>Редактировать</span>
                </button>

                <div className="menu-wrapper" ref={menuRef}>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowMenu(showMenu === item._id ? null : item._id);
                        }}
                        className="menu-button"
                    >
                        •••
                    </button>
                    
                    {showMenu === item._id && (
                        <div 
                            className="dropdown-menu" 
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            <button
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenUrl(e);
                                }}
                                className="menu-item"
                            >
                                <OpenInNewIcon style={{ fontSize: 16 }} />
                                <span>Перейти к объявлению</span>
                            </button>
                            <button
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowLinkFormatModal(true);
                                }}
                                className="menu-item"
                            >
                                <LinkIcon style={{ fontSize: 16 }} />
                                <span>Получить ссылку с метками</span>
                            </button>
                            
                            {showLinkFormatModal && (
                                <div 
                                    className="submenu-dropdown"
                                    style={{
                                        position: 'absolute',
                                        left: '100%',
                                        top: '0',
                                        backgroundColor: 'white',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                        borderRadius: '4px',
                                        padding: '8px 0',
                                        zIndex: 10,
                                        width: '220px'
                                    }}
                                >
                                    {adNetworks.map((network, index) => (
                                        <button
                                            key={index}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => handleGetTrackedUrl(e, network)}
                                            className="menu-item"
                                            style={{
                                                textAlign: 'left',
                                                width: '100%'
                                            }}
                                        >
                                            {network.name}
                                        </button>
                                    ))}
                                </div>
                            )}
                            
                            <div className="menu-divider" />
                            <button
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteClick(e);
                                }}
                                className="menu-item delete"
                            >
                                <DeleteIcon style={{ fontSize: 16 }} />
                                <span>Удалить</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ActionButtons;